var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.96166 23.2458C7.20141 23.2458 5.44116 23.2528 3.68091 23.244C1.46864 23.2326 0.0153267 21.6965 0.00023161 19.3865C-0.0123476 17.513 0.192274 15.6894 1.02586 13.9919C1.75713 12.5031 2.92112 11.6995 4.51281 11.5611C4.88096 11.5286 5.19293 11.6794 5.49818 11.8678C6.10953 12.2455 6.67811 12.688 7.35823 12.9544C8.85264 13.5406 10.2364 13.2839 11.5714 12.4698C11.7039 12.3892 11.8289 12.2954 11.9589 12.2086C13.304 11.3139 14.7229 11.4506 15.9221 12.5793C16.4958 13.1191 16.9067 13.7781 17.1885 14.5151C17.8736 16.3072 18.1495 18.1746 17.9214 20.0902C17.7034 21.9243 16.2719 23.2178 14.494 23.2379C12.6499 23.2589 10.8058 23.2423 8.96166 23.2423C8.96166 23.2449 8.96166 23.2458 8.96166 23.2458Z",
    fill: "#FCD535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85278 0.749023C11.7712 0.749023 14.0648 3.14223 14.0648 6.18566C14.0639 9.19754 11.7066 11.6705 8.8511 11.6547C5.96962 11.6389 3.62318 9.1844 3.62151 6.18478C3.62067 3.17553 5.95621 0.749023 8.85278 0.749023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profileImg.f7880ea0420460cb45e141c56a11f997.svg";
export { ForwardRef as ReactComponent };